export default "__VITE_ASSET__BvSLnxSR__"